import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    options: [],
    filters: {
      period: [2017,2018],
      state: 'Todos',
      matters: 'Todos',
      sex: 'Todos',
      firstAge: '',
      secondAge: '',
      occupation: 'Todas',
      intervention: 'Todas',
      referred: 'Todas',
      municipality: 'Todos',
      lastSeenPlace: 'Todos',
      victimYears: [2017, 2018],
      status: 'Todos',
      firstVictimAge: '',
      secondVictimAge: '',
      victimSex: ''
    },
    min: 2017,
    max: 2018,
    minVictimYear: 2017,
    maxVictimYear: 2018,
    reports: [],
    victims: [],
    host: 'https://frayjuandelarios.datacivica.org/',
      /*process.env.NODE_ENV === "production"
        ? "https://frayjuandelarios.datacivica.org/"
        : "http://localhost:1337/",*/
    filteredReports: [],
    filteredVictims: [],
    filteredStates: [],
    filteredVictimsStates: [],
    selection: undefined,
    victimSelection: undefined,
    chartSelection: "sexualIdentity",
    chartColors: [
      "#b02020",
      "#3e3082",
      "#d38d00",
      "#1d91c0",
      "#35871b",
      "#225ea8"
    ]
  },
  mutations: {
    setOptions(state, value) {
      state.options = value;
    },
    resetFilters(state) {
      state.filters = {
        period: [state.min,state.max],
        state: 'Todos',
        matters: 'Todos',
        sex: 'Todos',
        firstAge: '',
        secondAge: '',
        occupation: 'Todas',
        intervention: 'Todas',
        referred: 'Todas',
        municipality: 'Todos',
        lastSeenPlace: 'Todos',
        victimYears: [state.minVictimYear,state.maxVictimYear],
        status: 'Todos',
        firstVictimAge: '',
        secondVictimAge: '',
        victimSex: 'Todos'
      }
    },
    setStateFilter(state, value) {
      state.filters.state = value;
    },
    setMattersFilter(state, value) {
      state.filters.matters = value;
    },
    setSexFilter(state, value) {
      state.filters.sex = value;
    },
    setFirstAgeFilter(state, value) {
      state.filters.firstAge = value;
    },
    setSecondAgeFilter(state, value) {
      state.filters.secondAge = value;
    },
    setPeriodFilter(state, value) {
      state.filters.period = value;
    },
    setOccupationFilter(state, value) {
      state.filters.occupation = value;
    },
    setCivilStatusFilter(state, value) {
      state.filters.civilStatus = value;
    },
    setInterventionFilter(state, value) {
      state.filters.intervention = value;
    },
    setReferredFilter(state, value) {
      state.filters.referred = value;
    },
    setMunicipalityFilter(state, value) {
      state.filters.municipality = value;
    },
    setLastSeenPlaceFilter(state, value) {
      state.filters.lastSeenPlace = value;
    },
    setVictimYearsFilter(state, value) {
      state.filters.victimYears = value;
    },
    setStatusFilter(state, value) {
      state.filters.status = value;
    },
    setFirstVictimAgeFilter(state, value) {
      state.filters.firstVictimAge = value;
    },
    setSecondVictimAgeFilter(state, value) {
      state.filters.secondVictimAge = value;
    },
    setVictimSexFilter(state, value) {
      state.filters.victimSex = value;
    },
    setReports(state, value) {
      state.reports = value;
      if (value.length > 0){
        state.min = +_.minBy(value, "year")["year"];
        state.max = +_.maxBy(value, "year")["year"];  
      }
      state.filters.period = [state.min,state.max];
    },
    setVictims(state, value) {
      state.victims = value;
      if(value.length > 0){
        state.minVictimYear = +_.minBy(value, "year")["year"];
        state.maxVictimYear = +_.maxBy(value, "year")["year"];
      }else{
        state.minVictimYear = 2000;
        state.maxVictimYear = new Date().getFullYear();
      }
      state.filters.victimYears = [state.minVictimYear,state.maxVictimYear];

    },
    setFilteredReports(state, value) {
      state.filteredReports = value;
    },
    setFilteredVictims(state, value) {
      state.filteredVictims = value;
    },
    setFilteredStates(state, value) {
      state.filteredStates = value;
    },
    setFilteredVictimsStates(state, value) {
      state.filteredVictimsStates = value;
    },
    setSelection(state, value) {
      state.selection = value;
    },
    setVictimSelection(state, value) {
      state.victimSelection = value;
    }
  },
  getters: {
    selected: state => {
      return state.selection;
    }
  },
  actions: {}
});
